export const trace = (message, show, extraData = '') => {
  if (!show) return;
  console.log(message, extraData);
};
